<template>
  <div>
    <tetris></tetris>
  </div>
</template>

<script>
import Tetris from "../components/tetris";
export default {
  name: "Tetris.container",
  data() {
    return {};
  },
  components: { Tetris }
};
</script>

<style scoped></style>
